import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Button, Typography, Grid, Box, ImageList,ImageListItem } from '@mui/material'
import satelitku1 from '../../assets/img/satelitku1.png';
import satelitku2 from '../../assets/img/satelitku2.png';
import aessims1 from '../../assets/img/aessims1.png';
import aessims2 from '../../assets/img/aessims2.png';
import baby1 from '../../assets/img/baby1.png';
import baby2 from '../../assets/img/baby2.png';
import hiv1 from '../../assets/img/hiv1.png';
import hiv2 from '../../assets/img/hiv2.png';
import lontara1 from '../../assets/img/lontara1.png';
import lontara2 from '../../assets/img/lontara2.png';
import ojs1 from '../../assets/img/ojs1.png';
import ojs2 from '../../assets/img/ojs2.png';
import spec1 from '../../assets/img/spec1.png';
import spec2 from '../../assets/img/spec2.png';

const items = [
    {
        name: "Satelitku",
        description: "Satelitku is an Android application that can track the real-time position of Indonesian satellites LAPAN-A1/TUBSAT, LAPAN-A2/ORARI, and LAPAN-A3/IPB. This software can also notify users of the Acquisition of Signal time of the satellites based on the ground station's position or the user's position.",
        img: [
          {
          img: satelitku1,
          title: 'satelitku1',
          },{
            img: satelitku2,
            title: 'satelitku2',
          }
        ],
        url:'https://play.google.com/store/apps/details?id=lapan.pusteksat.satelitku',
        orien:2
    },
    {
        name: "AESSIMS",
        description: "The Artificial Earth Satellite Simulation Software provides real-time trajectory simulations for celestial objects such as satellites and space stations in three-dimensional Earth. This software provides dynamic simulation to the user by allowing the user to configure their own satellite elements and ground station positions. Additionally, AESSIMS also calculates satellite access time relative to ground station’s position and provides all the information to users.",
        img: [
          {
          img: aessims1,
          title: 'aessims1',
          },{
            img: aessims2,
            title: 'aessims2',
          }
        ],
        url:'https://satelitku.brin.go.id',
        orien:1
    },
    {
        name: "Phone Specification",
        description: "An Android application that provides users with detailed and accurate information about mobile phones or tablet specifications, including its make and model, operating system and version, processor and GPU, display size and resolution, camera specifications, battery capacity, storage capacity and RAM, and more.",
        img: [
          {
          img: spec1,
          title: 'spec1',
          },{
            img: spec2,
            title: 'spec2',
          }
        ],
        url:'https://play.google.com/store/apps/details?id=com.pepsdev.spekhp',
        orien:2
    },
    {
        name: "Palontaraki (ᨄᨒᨚᨈᨑᨀᨗ)",
        description: "Palontaraki means “Make it Lontara.” The word was taken from the language of one ethnic tribe in Makassar, Indonesia, called “Lontara.” Palontaraki is a simple Android application that will give an advantage to Android users to write text in Lontara fonts.",
        img: [
          {
          img: lontara1,
          title: 'lontara1',
          },{
            img: lontara2,
            title: 'lontara2',
          }
        ],
        url:'https://play.google.com/store/apps/details?id=com.pepsdev.palontaraki',
        orien:2
    },
    {
        name: "AH Baby Massage",
        description: "Android-based Baby Massage application intended for parents who have attended baby massage training carried out by competent midwives in the implementation of baby massage.",
        img: [
          {
          img: baby1,
          title: 'baby1',
          },{
            img: baby2,
            title: 'baby2',
          }
        ],
        url:'https://play.google.com/store/apps/details?id=ah.baby.massage',
        orien:2
    },
    {
        name: "AIS-CARE HA",
        description: "AIS-Care HA (Application Intervention System) is an application designed to provide education, automatic reminders, and counseling to HIV patients. The application aims to improve the quality of life for people living with HIV and to help doctors, nurses, and other health workers monitor the progress of patients undergoing treatment, as well as provide patients with easy access to information and consultation without having to meet directly with officers in private.",
        img: [
          {
          img: hiv1,
          title: 'hiv1',
          },{
            img: hiv2,
            title: 'hiv2',
          }
        ],
        url:'https://play.google.com/store/apps/details?id=ais.care.ha',
        orien:2
    },
    {
        name: "Pelamonia Medical Journals",
        description: "Implementation of the Journal System for Pelamonia Health Sciences Institute of Makassar using Open Journal System (OJS), an open-source software for the management of peer-reviewed academic journals created by the Public Knowledge Project and released under the GNU General Public License.",
        img: [
          {
          img: ojs1,
          title: 'ojs1',
          },{
            img: ojs2,
            title: 'ojs2',
          }
        ],
        url:'https://ojs.iikpelamonia.ac.id/',
        orien:1
    },
]
function MasonryImageList(props) {
  return (
    <Box sx={{ maxWidth: {lg:'80%',md:'80%',sm:'auto', xs:'auto'}, overflowY: 'hidden'}}>
      <ImageList variant="masonry" cols={props.orien} gap={8} >
        {props.itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={`${item.img}?w=248&fit=crop&auto=format`}
              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              alt={item.title}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}
function Item(props) {
    return (
        <Grid 
            container 
            spacing={{lg: 5, md: 5, sm:3, xs:3}}
            direction="row"
            justifyContent="center"
            alignItems="flex-start" >
            <Grid item  lg={12} md={12} sm={12} xs={12} sx={{textAlign: {lg:'center', md:'center',sm:'center',xs:'end'}}}>
              <Typography variant='h4' sx={{textDecoration:'underline', }}>
                Works
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{textAlign:'end'}}>
              <Box>
                <Typography variant='h4'>
                  {props.item.name}
                </Typography>
                <Typography variant='body'>
                  {props.item.description}
                </Typography>
              </Box>
                <Button variant="text" href={props.item.url} target="_blank">
                    More Info
                </Button>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <MasonryImageList itemData={props.item.img} orien={props.item.orien}/>
            </Grid>
        </Grid>
    )
}

export default function Products() {
  return (
    <Carousel>
      {
          items.map( (item, i) => <Item key={i} item={item} /> )
      }
    </Carousel>
  )
}